import React, {useState, useRef} from 'react';
import {Popup, List} from '../../../components';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import PublicIcon from '@material-ui/icons/Public';
import PostAddIcon from '@material-ui/icons/PostAdd';
import FacebookIcon from '@material-ui/icons/Facebook';
import MapIcon from '@material-ui/icons/Map';
import Google_search from '../Search/google_search_form';
import AddIcon from '@material-ui/icons/Add';
import QueueIcon from '@material-ui/icons/Queue';



export default function Add_data(props){
  const[type, setType]=useState();
  let submit_button=useRef();

  function select_type(data){setType(data.type)}
  function submit_form(){submit_button.current.click();}
  return(
      <Popup {...props} closed={()=>{setType(undefined)}} accept_button_click={(type=='google_maps_search')?submit_form:undefined} accept_button={(type=='google_maps_search')?'Submit':undefined} content={(type=='google_maps_search')?<div><Google_search submit_button_ref={submit_button} list_id={props.list_id}/></div>:(type=='facebook_search')?<Facebook_search/>:(type=='automated_search')?<Automated_search select_type={select_type}/>:(type=='upload_csv')?<Upload_csv/>:(type=='from_other_lists')?<From_other_lists/>:<First_step select_type={select_type}/>}/>
   );
}


function First_step(props){
  return(
    <div style={{width:'80vw', height:'60vh', paddingLeft:'0px'}}><List onClick={props.select_type} list_data={[{type:'automated_search', icon:<PublicIcon/>, main_text:'Automated search'}, {type:'upload_csv', icon:<CloudUploadIcon/>, main_text:'Upload CSV'}, {type:'from_other_lists', icon:<PostAddIcon/>, main_text:'Move from another list'}, {type:'new_company', icon:<QueueIcon/>, main_text:'New company'}]}/></div>
  )
}


function Upload_csv(props){

}

function Automated_search(props){
  return(
    <div style={{width:'80vw', height:'60vh', paddingLeft:'0px'}}><List onClick={props.select_type} list_data={[{type:'google_maps_search', icon:<MapIcon/>, main_text:'Google maps search'}, {type:'facebook_search', icon:<FacebookIcon/>, main_text:'Facebook search'}]}/></div>
  )
}

function From_other_list(props){

}
